"use client"

import { useState } from "react"
import { ChevronDown, HelpCircle } from "lucide-react"

export default function FAQ() {
  const [expandedItem, setExpandedItem] = useState(0)

  const faqItems = [
    {
      question: "No recibí el Token de actualización de contraseña. ¿Qué hago?",
      answer: `<p>Verifica que el correo con el que estás solicitando el cambio de contraseña corresponde a la cuenta con la que has estado suscrito a <strong>TCS GO!</strong></p>
        <p>Si el correo efectivamente corresponde a tu cuenta activa TCS GO!, comunícate con nuestro equipo de soporte al <a href="https://wa.me/50369383613" target="_blank" rel="noopener noreferrer">WhatsApp</a> para solicitar un cambio de contraseña manual.</p>`,
    },
    {
      question: "Pagué mi suscripción y no se activó el servicio.",
      answer: `<p>Comprueba que tienes una suscripción activa de acuerdo con la plataforma en la que te hayas suscrito:</p>
        <ul style="margin-left: 20px; list-style: disc;">
          <li><strong>Apple ID:</strong> Apartado "Apple ID" en Configuración / "Suscripciones" / Elije la aplicación TCS Go! para comprobar su estado.</li>
          <li><strong>Google Play Store:</strong> Apartado "Pagos y Suscripciones" / "Suscripciones" / Elije la aplicación TCS Go! para "Administrar suscripción" y comprobar su estado.</li>
          <li><strong>Tcsgo.com:</strong> inicia sesión, presiona el ícono de usuario al extremo derecho de la pantalla, y dirígete de "Pagos" ahí podrás comprobar si tienes una suscripción activa.</li>
        </ul>`,
    },
    {
      question: "¿Cuáles son las formas de pago para suscribirme a TCS GO?",
      answer: `<p>Las vías oficiales para suscripción son:</p>
        <ul style="margin-left: 20px; list-style: disc;">
          <li>Directamente entrando en tu navegador a <strong>www.tcsgo.com</strong></li>
          <li>Descargando la <strong>App TCS GO</strong> a través de tu dispositivo iOS, TVOS, Android o Android TV.</li>
        </ul>
        <p style="margin-top: 15px;"><strong>Métodos de pago:</strong></p>
        <ul style="margin-left: 20px; list-style: disc;">
          <li>Tarjetas de crédito o débito asociados a tus dispositivos.</li>
          <li>Tarjetas de crédito o débito en www.tcsgo.com</li>
        </ul>
        <p style="margin-top: 15px;">A partir de agosto 2024, comprobarás tu pago al recibir un correo electrónico con los detalles de la suscripción.</p>`,
    },
    {
      question: "¿Cómo puedo cancelar mi suscripción?",
      answer: `<ul style="margin-left: 20px; list-style: disc;">
          <li><strong>iOS:</strong> apartado "Apple ID" en Configuración / "Suscripciones"/ Elije la aplicación TCS GO! / Cancelar suscripción.</li>
          <li><strong>Android en Play Store:</strong> apartado "Pagos y Suscripciones" / "Suscripciones" / Elije la aplicación TCS GO! para "Administrar suscripción" / Cancelar suscripción.</li>
          <li><strong>Y en tcsgo.com:</strong> inicia sesión, presiona el ícono de usuario al extremo derecho de la pantalla, y dirígete a "Pagos". Cancela tu suscripción. Si no puedes realizarlo por esa vía, solicita a nuestro equipo de soporte la cancelación de tu cuenta.</li>
        </ul>`,
    },
    {
      question: "¿Cómo iniciar sesión en Smart TV? (TUTORIAL)",
      answer: `<ul style="margin-left: 20px; list-style: disc;">
          <li><strong>Apple TV:</strong> Ve a App Store, descarga la aplicación y ábrela, inicia sesión y la plataforma te solicitará escanear un código QR con tu celular que te llevará a una pantalla donde deberás ingresar tus credenciales.</li>
          <li><strong>Android TV:</strong> Ve a Google Play Store, descarga la aplicación y ábrela, inicia sesión y la plataforma te solicitará escanear un código QR con tu celular que te llevará a una pantalla donde deberás ingresar tus credenciales.</li>
        </ul>`,
    },
    {
      question: "¿Qué puedo ver en vivo en TCS GO?",
      answer: `<p>La programación de TCS GO varía según el país en el que te encuentres, por lo que tenemos 3 categorías de programación:</p>
        <ul style="margin-left: 20px; list-style: disc;">
          <li><strong>A. El Salvador:</strong> Visita: <a href="https://www.tcsahora.com/programacion-tv-tcs/" target="_blank" rel="noopener noreferrer">tcsahora.com/programacion-tv-tcs/</a></li>
          <li><strong>B. Estados Unidos:</strong> Navega el sitio <a href="https://www.tcsgo.com/" target="_blank" rel="noopener noreferrer">tcsgo.com</a> para conocer los contenidos disponibles en tu país.</li>
          <li><strong>C. Resto del Mundo:</strong> Navega el sitio <a href="https://www.tcsgo.com/" target="_blank" rel="noopener noreferrer">tcsgo.com</a> para conocer los contenidos disponibles en tu país.</li>
        </ul>`,
    },
    {
      question: "¿Dónde puedo conocer la programación Deportiva de TCS GO?",
      answer: `<p>Para El Salvador: <a href="https://www.tcsahora.com/programacion-tv-tcs/" target="_blank" rel="noopener noreferrer">tcsahora.com/programacion-tv-tcs/</a></p>
        <p>Para USA y resto del mundo: Visita nuestras redes sociales y tendrás información actualizada de los eventos deportivos a transmitirse en TCS GO USA.</p>`,
    },
    {
      question: "No puedo ver un contenido.",
      answer: `<p>Repórtalo a nuestro Equipo de Soporte <a href="https://wa.me/50369383613" target="_blank" rel="noopener noreferrer">por WhatsApp</a> para recibir asistencia inmediata.</p>`,
    },
    {
      question: "Consulta no relacionada al servicio TCS GO!",
      answer: `<p>Si tienes alguna consulta no relacionada al servicio TCS GO! pero sí a Telecorporación Salvadoreña, puedes enviar un correo a: <a href="mailto:info.mercadeo@tcs246.com">info.mercadeo@tcs246.com</a></p>`,
    },
  ]

  return (
    <div className="page-wrapper">
      <main className="page-main">
        <div className="container">
          <section className="hero-section faq-hero">
            <div className="hero-content">
                <div className="faq-icon-wrapper">
                  <HelpCircle className="faq-icon" />
                </div>
              <h1 className="hero-title">
                Centro de Ayuda
              </h1>
              <p className="hero-subtitle">
                Encuentra respuestas a las preguntas más comunes sobre tu suscripción a TCS GO
              </p>
            </div>
          </section>

          <div className="faq-container">
            <div className="faq-list">
              {faqItems.map((item, index) => (
                <div key={index} className={`faq-item ${expandedItem === index ? "expanded" : ""}`}>
                  <button className="faq-header" onClick={() => setExpandedItem(expandedItem === index ? -1 : index)}>
                    <div className="faq-number">{index + 1}</div>
                    <div className="faq-header-content">
                      <h3 className="faq-question">{item.question}</h3>
                      <ChevronDown className={`chevron-faq ${expandedItem === index ? "rotated" : ""}`} />
                    </div>
                  </button>
                  {expandedItem === index && (
                    <div className="faq-answer">
                      <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <section className="faq-support-section">
            <div className="support-card">
              <h3 className="support-title">¿No encuentras tu respuesta?</h3>
              <p className="support-text">Nuestro equipo de soporte está disponible para ayudarte</p>
              <a href="https://wa.me/50369383613" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
                Contactar por WhatsApp
              </a>
            </div>
          </section>
        </div>
      </main>
    </div>
  )
}



// import React, { useEffect, useMemo } from 'react';
// import DOMPurify from 'dompurify';
// import classNames from 'classnames';
// import { marked } from 'marked';

// /* import styles from './Faq.module.scss'; */

// type HTMLProps = {
//   htmlString: string;
//   className?: string;
//   tag?: string;
// };

// const HTMLRenderer: React.FC<HTMLProps> = ({ htmlString, tag = 'div' }) => {
//   const sanitizedHTMLString = DOMPurify.sanitize(htmlString);

//   return React.createElement(tag, {
//     dangerouslySetInnerHTML: { __html: sanitizedHTMLString },
//   });
// };

// type MarkdownProps = {
//   markdownString: string;
//   className?: string;
//   inline?: boolean;
//   tag?: string;
// };

// const renderer = {
//   link(href: string, title: string, text: string) {
//     const externalLink = /^(https?|www\.|\/\/)/.test(href || '');
//     const targetAttr = externalLink ? 'target="_blank"' : undefined;
//     const relAttr = externalLink ? 'rel="noopener"' : undefined;
//     const titleAttr = title ? `title="${title}"` : undefined;
//     const attributes = [targetAttr, relAttr, titleAttr].filter(Boolean);

//     return `<a href="${href}" ${attributes.join(' ')}>${text}</a>`;
//   },
// };

// marked.use({ renderer });

// const MarkdownComponent: React.FC<MarkdownProps> = ({ markdownString, className, tag = 'div', inline = false }) => {
//   const sanitizedHTMLString = useMemo(() => {
//     const parseDelegate = inline ? marked.parseInline : marked.parse;
//     const dirtyHTMLString = parseDelegate(markdownString);

//     return DOMPurify.sanitize(dirtyHTMLString, { ADD_ATTR: ['target'] });
//   }, [inline, markdownString]);

//   return React.createElement(tag, { dangerouslySetInnerHTML: { __html: sanitizedHTMLString }, className: classNames(className) });
// };

// const Faq: React.FC = () => {
//   useEffect(() => {
//     const accordionItems = document.querySelectorAll('.accordion-item');

//     accordionItems.forEach(item => {
//       const title = item.querySelector('.accordion-title');
//       title?.addEventListener('click', () => {
//         item.classList.toggle('active');
//         const content = item.querySelector('.accordion-content') as HTMLElement;

//         if (item.classList.contains('active')) {
//           content.style.display = 'block';
//         } else {
//           content.style.display = 'none';
//         }
//       });
//     });
//   }, []);

//   return (

//     <div className="accordion-container" style={{ backgroundColor: '#1a1a1a', padding: '30px', borderRadius: '8px', textAlign: 'justify', margin: '20px' }}>
//       <div style={{ textAlign: 'center' }}>
//         <img
//           src="http://tcsahora-1.s3.us-east-2.amazonaws.com/wp-content/uploads/2024/09/02095538/tvOS_App-Icon-Image_1280x768-1.png"
//           alt="TCS GO Logo"
//           style={{

//             margin: '0 auto 20px auto',
//             maxWidth: '200px',
//             height: 'auto',
//             // Puedes ajustar este valor según el diseño que desees
//           }}
//         />
//       </div>

//       <div className="accordion-item" style={{ borderBottom: "1px solid #ccc", marginBottom: '7px' }}>
//         <div className="accordion-title" style={{ cursor: 'pointer', fontSize: '25px', marginBottom: '12px' }}> 1. No recibí el Token de actualización de contraseña. ¿Qué hago?</div>
//         <div className="accordion-content" style={{ display: 'none', padding: '15px', backgroundColor: '#333' }}>
//           <p>Verifica que el correo con el que estás solicitando el cambio de contraseña corresponde a la cuenta con la que
//             has estado suscrito a TCS GO!</p>
//           <p>Si el correo efectivamente corresponde a tu cuenta activa TCS GO!, comunícate con nuestro equipo de soporte al
//             <a href="https://wa.me/50369383613" style={{ color: '#00aaff' }}>https://wa.me/50369383613</a> para solicitar un cambio de contraseña
//             manual.</p>
//         </div>
//       </div>

//       <div className="accordion-item" style={{ borderBottom: "1px solid #ccc", marginBottom: '7px' }}>
//         <div className="accordion-title" style={{ cursor: 'pointer', fontSize: '25px', marginBottom: '12px' }}>2. Pagué mi suscripción y no se activó el servicio.</div>
//         <div className="accordion-content" style={{ display: 'none', padding: '15px', backgroundColor: '#333' }}>
//           <p>Comprueba que tienes una suscripción activa de acuerdo con la plataforma en la que te hayas suscrito:</p>
//           <ul>
//             <li>Apple ID: Apartado “Apple ID” en Configuración / “Suscripciones” / Elije la aplicación TCS Go! para comprobar
//               su estado.</li>
//             <li>Google Play Store: Apartado “Pagos y Suscripciones” / “Suscripciones” / Elije la aplicación TCS Go! para
//               “Administrar suscripción” y comprobar su estado.</li>
//             <li>Tcsgo.com: inicia sesión, presiona el ícono de usuario al extremo derecho de la pantalla, y dirígete de
//               “Pagos” ahí podrás comprobar si tienes una suscripción activa, y verificar los últimos 4 dígitos de la
//               tarjeta con la que tienes o no activo el servicio.</li>
//           </ul>
//         </div>
//       </div>
//       <div className="accordion-item" style={{ borderBottom: "1px solid #ccc", marginBottom: '7px' }}>
//         <div className="accordion-title" style={{ cursor: 'pointer', fontSize: '25px', marginBottom: '12px' }}>3. ¿Cuáles son las formas de pago para suscribirme a TCS GO?</div>
//         <div className="accordion-content" style={{ display: 'none', padding: '15px', backgroundColor: '#333' }}>
//           <p>Las vías oficiales para suscripción son:</p>
//           <ul>
//             <li>Directamente entrando en tu navegador a <a href="http://www.tcsgo.com/" style={{ color: '#00aaff' }}>www.tcsgo.com</a></li>
//             <li>Descargando la App TCS GO” a través de tu dispositivo iOS, TVOS, Android o Android TV.</li>
//           </ul>
//           <p>Métodos de pago:</p>
//           <ul>
//             <li>Tarjetas de crédito o débito asociados a tus dispositivos.</li>
//             <li>Tarjetas de crédito o débito en <a href="http://www.tcsgo.com/" style={{ color: '#00aaff' }}>www.tcsgo.com</a></li>
//           </ul>
//           <p>A partir de agosto 2024, comprobarás tu pago al recibir un correo electrónico con los detalles de la suscripción.</p>
//         </div>
//       </div>
//       <div className="accordion-item" style={{ borderBottom: "1px solid #ccc", marginBottom: '7px' }}>
//         <div className="accordion-title" style={{ cursor: 'pointer', fontSize: '25px', marginBottom: '12px' }}>4. ¿Cómo puedo cancelar mi suscripción?</div>
//         <div className="accordion-content" style={{ display: 'none', padding: '15px', backgroundColor: '#333' }}>
//           <ul>
//             <li>iOS: apartado “Apple ID” en Configuración / “Suscripciones”/ Elije la aplicación TCS GO! / Cancelar suscripción.</li>
//             <li>Android en Play Store: apartado “Pagos y Suscripciones” / “Suscripciones” / Elije la aplicación TCS GO! para
//               “Administrar suscripción” / Cancelar suscripción.</li>
//             <li>Y en tcsgo.com: inicia sesión, presiona el ícono de usuario al extremo derecho de la pantalla, y dirígete a
//               “Pagos”. Cancela tu suscripción. Si no puedes realizarlo por esa vía, solicita a nuestro equipo de soporte
//               la cancelación de tu cuenta, indicando tus datos: correo electrónico con el que tienes la suscripción,
//               Nombre completo, últimos 4 dígitos de tu tarjeta.</li>
//           </ul>
//         </div>
//       </div>
//       <div className="accordion-item" style={{ borderBottom: "1px solid #ccc", marginBottom: '7px' }}>
//         <div className="accordion-title" style={{ cursor: 'pointer', fontSize: '25px', marginBottom: '12px' }}>5. ¿Cómo iniciar sesión en Smart TV? (TUTORIAL)</div>
//         <div className="accordion-content" style={{ display: 'none', padding: '15px', backgroundColor: '#333' }}>
//           <ul>
//             <li><strong>Apple TV:</strong> Ve a App Store, descarga la aplicación y ábrela, inicia sesión y la plataforma te
//               solicitará escanear un código QR con tu celular que te llevará a una pantalla donde deberás ingresar tus
//               credenciales.</li>
//             <li><strong>Android TV:</strong> Ve a Google Play Store, descarga la aplicación y ábrela, inicia sesión y la
//               plataforma te solicitará escanear un código QR con tu celular que te llevará a una pantalla donde deberás
//               ingresar tus credenciales.</li>
//           </ul>
//         </div>
//       </div>
//       <div className="accordion-item" style={{ borderBottom: "1px solid #ccc", marginBottom: '7px' }}>
//         <div className="accordion-title" style={{ cursor: 'pointer', fontSize: '25px', marginBottom: '12px' }}>6. ¿Qué puedo ver en vivo en TCS GO?</div>
//         <div className="accordion-content" style={{ display: 'none', padding: '15px', backgroundColor: '#333' , overflow:'hidden'}}>
//           <p>La programación de TCS GO varía según el país en el que te encuentres, por lo que tenemos 3 categorías de programación:</p>
//           <ul>
//             <li><strong>A. El Salvador:</strong> Visita: <a href="https://www.tcsahora.com/programacion-tv-tcs/" style={{ color: '#00aaff' }}>https://www.tcsahora.com/programacion-tv-tcs/</a></li>
//             <li><strong>B. Estados Unidos:</strong> Navega el sitio <a href="https://www.tcsgo.com/" style={{ color: '#00aaff' }}>https://www.tcsgo.com/</a> para conocer los contenidos disponibles en tu país.</li>
//             <li><strong>C. Resto del Mundo:</strong> Navega el sitio <a href="https://www.tcsgo.com/" style={{ color: '#00aaff' }}>https://www.tcsgo.com/</a> para conocer los contenidos disponibles en tu país.</li>
//           </ul>
//         </div>
//       </div>
//       <div className="accordion-item" style={{ borderBottom: "1px solid #ccc", marginBottom: '7px' }}>
//         <div className="accordion-title" style={{ cursor: 'pointer', fontSize: '25px', marginBottom: '12px' }}>7. ¿Dónde puedo conocer la programación Deportiva de TCS GO?</div>
//         <div className="accordion-content" style={{ display: 'none', padding: '15px', backgroundColor: '#333' , overflow:'hidden'}}>
//           <p>Para El Salvador: <a href="https://www.tcsahora.com/programacion-tv-tcs/" style={{ color: '#00aaff' }}>https://www.tcsahora.com/programacion-tv-tcs/</a></p>
//           <p>Para USA y resto del mundo: Visita nuestras redes sociales y tendrás información actualizada de los eventos deportivos a transmitirse en TCS GO USA.</p>
//         </div>
//       </div>
//       <div className="accordion-item" style={{ borderBottom: "1px solid #ccc", marginBottom: '7px' }}>
//         <div className="accordion-title" style={{ cursor: 'pointer', fontSize: '25px', marginBottom: '12px' }}>8. No puedo ver un contenido.</div>
//         <div className="accordion-content" style={{ display: 'none', padding: '15px', backgroundColor: '#333' }}>
//           <p>Repórtalo a nuestro Equipo de Soporte <a href="https://wa.me/5036938361" style={{ color: '#00aaff' }}>https://wa.me/5036938361</a> para recibir asistencia.</p>
//         </div>
//       </div>
//       <div className="accordion-item" style={{ borderBottom: "1px solid #ccc", marginBottom: '7px' }}>
//         <div className="accordion-title" style={{ cursor: 'pointer', fontSize: '25px', marginBottom: '12px' }}>9. Consulta no relacionada al servicio TCS GO!</div>
//         <div className="accordion-content" style={{ display: 'none', padding: '15px', backgroundColor: '#333' }}>
//           <p>Si tienes alguna consulta no relacionada al servicio TCS GO! pero sí a Telecorporación Salvadoreña, puedes enviar un correo a: <a href="mailto:info.mercadeo@tcs246.com" style={{ color: '#00aaff' }}>info.mercadeo@tcs246.com</a></p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export { MarkdownComponent, HTMLRenderer };
// export default Faq;
